import {
  Apiv2GetRequest,
  Apiv2PostRequest,
  Apiv2DeleteRequest,
  Apiv2PutRequest,
  Apiv2PostMultipart,
  Apiv2BlobGetRequest,
} from '../../api-v2';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Daftar Slip Gaji Karyawan',
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_slip_gaji',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
          backgroundColor: '#266f41',
          color: '#fff',
        },
        tdClass: 'bg-primary bg-soft text-primary text-center',
      },
      {
        key: 'kode_slip',
        label: 'Kode',
        thStyle: {
          backgroundColor: '#266f41',
          color: '#fff',
        },
        tdClass: 'bg-primary bg-soft text-primary',
      },
      {
        key: 'tgl_slip',
        label: 'Tgl Slip',
        thStyle: {
          backgroundColor: '#266f41',
          color: '#fff',
        },
        tdClass: 'bg-primary bg-soft text-primary',
      },
      {
        key: 'tgl_periode',
        label: 'Periode',
        thStyle: {
          backgroundColor: '#266f41',
          color: '#fff',
        },
        tdClass: 'bg-primary bg-soft text-primary',
      },
      {
        key: 'total_penambahan',
        label: 'Total Gaji',
        tdClass: 'text-end',
        thStyle: {
          textAlign: 'center',
        },
      },
      {
        key: 'total_potongan',
        label: 'Total Potongan',
        thStyle: {
          textAlign: 'center',
        },
        tdClass: 'text-end',
      },
      {
        key: 'total_slip',
        label: 'Total Diterima',
        thStyle: {
          backgroundColor: '#266f41',
          color: '#fff',
          textAlign: 'center',
        },
        tdClass: 'bg-primary bg-soft text-primary text-end',
      },
      {
        key: 'remark_slip',
        label: 'Keterangan',
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '100px',
          textAlign: 'center',
        },
      },
    ],
    detail: false,
    detail_periode: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeSlipGajiKaryawan(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchSlipGaji(context, params = null) {
    let result = await Apiv2GetRequest(`slip-gaji`, params);
    return !result.error ? result.data.object : [];
  },

  async getDetailSlipPeriode({ commit }, payload = null) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    let result = await Apiv2GetRequest(
      `slip-gaji/periode/${payload.id_slip_periode}`,
    );
    commit('changeSlipGajiKaryawan', {
      loading: false,
      detail_periode: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async getDownloadSlipGaji({ commit }, payload = {}) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    let result = await Apiv2BlobGetRequest(
      `slip-gaji/download/${payload.id_slip_gaji}`,
    );
    commit('changeSlipGajiKaryawan', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type: 'application/pdf',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'slip_gaji.pdf';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      commit('changeSlipGajiKaryawan', {
        loading: false,
      });

      return true;
    }
  },

  async getListDetailSlipGaji({ commit, state }, payload = {}) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
    };

    if (payload && payload.export) {
      let result = await Apiv2BlobGetRequest(
        `slip-gaji/detail/${data.id_slip_periode}`,
        params,
      );
      commit('changeSlipGajiKaryawan', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_slip_gaji.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        commit('changeSlipGajiKaryawan', {
          loading: false,
        });

        return true;
      }
    } else {
      let result = await Apiv2GetRequest(
        `slip-gaji/detail/${data.id_slip_periode}`,
        params,
      );
      commit('changeSlipGajiKaryawan', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getListSlipGaji({ commit, state }, payload = {}) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
    };

    if (payload && payload.export) {
      let result = await Apiv2BlobGetRequest(`slip-gaji`, params);
      commit('changeSlipGajiKaryawan', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_slip_periode.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        commit('changeSlipGajiKaryawan', {
          loading: false,
        });

        return true;
      }
    } else {
      let result = await Apiv2GetRequest(`slip-gaji`, params);
      commit('changeSlipGajiKaryawan', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailSlipGaji({ commit }, payload = null) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    let result = await Apiv2GetRequest(`slip-gaji/${payload.id}`);
    commit('changeSlipGajiKaryawan', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadFileLembur({ commit, state }, payload) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    const { data } = state;
    const result = await Apiv2PostMultipart(`upload-image`, payload);
    commit('changeSlipGajiKaryawan', {
      loading: false,
    });

    if (!result.error) {
      commit('changeSlipGajiKaryawan', {
        form: {
          ...data.form,
          file_lembur: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }, payload = null) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    const { data } = state;
    let result = await Apiv2PostRequest(
      `slip-gaji/import/${payload.id_slip_periode}`,
      {
        items: data.import_form || [],
      },
    );

    commit('changeSlipGajiKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createSlipGaji({ commit, state, dispatch }) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    let result = await Apiv2PostRequest(`slip-gaji`, state.data.form);
    commit('changeSlipGajiKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateSlipGaji({ commit, state, dispatch }, payload = null) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    let result = await Apiv2PutRequest(
      `slip-gaji/${payload.id}`,
      state.data.form,
    );

    commit('changeSlipGajiKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateStatusGaji({ commit, dispatch }, payload = null) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    let result = await Apiv2PostRequest(`slip-gaji/update-status`, {
      publish: 1,
      id_slip_periode: payload.id ? payload.id : '',
    });

    commit('changeSlipGajiKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteSlipGaji({ commit, dispatch }, payload = null) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    let result = await Apiv2DeleteRequest(`slip-gaji/${payload.id}`);
    commit('changeSlipGajiKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteDetailSlipGaji({ commit, dispatch }, payload = null) {
    commit('changeSlipGajiKaryawan', {
      loading: true,
    });

    let result = await Apiv2DeleteRequest(`slip-gaji/detail/${payload.id}`);
    commit('changeSlipGajiKaryawan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
